import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tell-us-more',
  templateUrl: './tell-us-more.component.html'
})
export class TellUsMoreComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


// WEBPACK FOOTER //
// J:/Develop/Plumit Maintenance/src/app/tell-us-more/tell-us-more.component.ts